<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height" :class="breakpoint">
        <router-view />
      </v-container>
    </v-main>

    <v-navigation-drawer
      v-model="drawerRight"
      color="primary"
      class="sidebar-navigation"
      width="25.57rem"
      app
      clipped
      right
      dark
    >
      <sidebar-navigation />
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-right
      light
      color="white"
      class="app-bar"
      :class="!appBarVisible ? 'app-bar-hidden': ''"
    >
      <v-container d-flex :class="breakpoint">
        <v-toolbar-title class="logo">
          <router-link to="/">
            <img :src="require('./assets/img/logo-island-epaper.png')" alt="The Island E-Paper" />
          </router-link>
        </v-toolbar-title>
        <nav-date-picker v-if="isPaperView" />
        <nav-time v-if="isPaperView" />
        <v-spacer class="hidden-xs-only"></v-spacer>
        <nav-actions
          :is-paper-view="isPaperView"
          :app-bar-visible="appBarVisible"
          v-on:toggleAppToolbar="toggleToolbar"
        />
        <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight">
          <v-icon v-if="drawerRight">mdi-close</v-icon>
        </v-app-bar-nav-icon>
      </v-container>
    </v-app-bar>

    <v-footer app inset tile padless color="grey darken-3" class="grey--text">
      <v-container d-flex :class="breakpoint">
        <!-- <span>PDF controls</span> -->
        <v-spacer></v-spacer>
        <footer-copyright />
      </v-container>
    </v-footer>
  </v-app>
</template>

<style lang="scss">
.app-bar.v-toolbar {
  overflow: hidden;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.2) !important;

  @media screen and (max-width: 600px) {
    padding: 0;
    height: 100px !important;
    width: 100vw;
    color: #fff;
  }

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: transparent;

    @media screen and (max-width: 1264px) {
      display: none;
    }
  }

  & > .v-toolbar__content {
    @media screen and (max-width: 600px) {
      padding: 0;
      background: red;
      height: 100px !important;
    }
    & > .container {
      @media screen and (max-width: 600px) {
        flex-wrap: wrap;
        flex-direction: column;
        padding: 0;
      }
    }
  }

  .logo {
    position: relative;
    overflow: visible;
    padding-right: 3rem;

    @media screen and (max-width: 960px) {
      padding-right: 1rem;
    }
    @media screen and (max-width: 600px) {
      //flex: 0 0 100%;
      position: absolute;
      top: 1rem;
      left: 0;
      right: 0;
      margin: auto;

      img {
        display: block;
        margin: auto;
        transform: translateY(-0.25rem);
      }
    }

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: -3rem;
      bottom: -0.5rem;
      left: -25rem;
      right: 0;
      background: #f00;
      z-index: -1;

      @media screen and (max-width: 600px) {
        display: none;
      }
    }

    a {
      display: block;
      position: relative;
      top: 55%;
      transform: translateY(-50%);

      @media screen and (max-width: 600px) {
        top: 0%;
        transform: translateY(0);
      }
    }
  }

  &.app-bar-hidden {
    transform: translateY(-100%) !important;
    overflow: visible;

    &:hover {
      transform: translateY(0) !important;
    }
  }

  .v-app-bar__nav-icon {
    @media screen and (max-width: 600px) {
      position: fixed;
      top: 0;
      right: 0;
    }
  }
}

.sidebar-navigation {
  @media screen and (max-width: 1264px) {
    z-index: 30 !important;
  }
  @media screen and (max-width: 960px) {
    z-index: 30 !important;
  }
  @media screen and (max-width: 600px) {
    z-index: 30 !important;
    width: 15rem !important;
  }

  // &.v-navigation-drawer--is-mobile.v-navigation-drawer--open {
  //   @media screen and (max-width: 960px) {
  //     width: 80vw !important;
  //     right: 0;
  //     transform: translateX(-130%) !important;
  //     height: 100% !important;
  //   }
  // }
}

.v-footer {
  @media screen and (max-width: 600px) {
    width: 100vw;
  }
}

.container.screen-lg,
.container.screen-md,
.container.screen-sm,
.container.screen-xs {
  max-width: 100%;
}
</style>

<script>
import SidebarNavigation from "@/components/layout/SidebarNavigation.vue";
import NavDatePicker from "@/components/layout/NavDatePicker.vue";
import NavTime from "@/components/layout/NavTime.vue";
import NavActions from "@/components/layout/NavActions.vue";
import FooterCopyright from "@/components/layout/FooterCopyright.vue";

export default {
  name: "App",
  components: {
    SidebarNavigation,
    NavDatePicker,
    NavTime,
    NavActions,
    FooterCopyright,
  },
  data: () => ({
    drawerRight: false,
    appBarVisible: true,
  }),
  computed: {
    isPaperView: function () {
      if (
        this.$route.path === "/" ||
        this.$route.path == "/home" ||
        this.$route.name == "Paper"
      ) {
        return true;
      } else {
        return false;
      }
    },
    breakpoint: function () {
      return `screen-${this.$vuetify.breakpoint.name}`;
    },
  },
  methods: {
    toggleToolbar() {
      this.appBarVisible = !this.appBarVisible;
    },
  },
};
</script>